module.exports = __webpack_public_path__ + "img/安全生产许可证.33869bbe.png";